import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GisDimsMapComponent } from 'src/app/main/shared/gis-dims-map/gis-dims-map.component';
import { InfomodalComponent } from 'src/app/main/shared/infomodal/infomodal.component';
import { DataService } from 'src/app/main/shared/services/data.service';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-heatindex-sidebar',
  templateUrl: './heatindex-sidebar.component.html',
  styleUrls: ['./heatindex-sidebar.component.scss']
})
export class HeatindexSidebarComponent implements OnInit {

  @Input() labelStrings: any;
  @Input() blockNum: number;
  @Output() playPos = new EventEmitter<any>();
  isInitialLoad: boolean = false;
  selected: string;
  dateIndexLength: any;
  activeRadioList: boolean[] = [];
  sourceOptions: any = ['IMD - GFS', 'ECMWF'];
  selectedSource: any = 'ECMWF';
  sourceMapping = {
    'IMD - GFS': 'IMD_LONG_RANGE',
    'ECMWF': 'ECMWF'
  }
  modalRef: any;
  queryParams: any;
  subscriptions: any = [];
  sessionStorage: any = {
    params: {}
  };
  destroy: any = new Subject();


  constructor(public gisUtils: UtilsService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private dataService: DataService,
    private gisMapComp: GisDimsMapComponent) {
    this.selected = this.router.url.split("/")[2]
    this.isInitialLoad = true
  }

  ngOnInit() {
    this.isInitialLoad = true;
    this.subscribeEvents()
    this.setParams()
  }

  subscribeEvents() {
    const selectedParamsRef = this.gisUtils.selectedParams.pipe(takeUntil(this.destroy)).subscribe((params: any) => {
      let sessionStorageSelectedParams: any = sessionStorage.getItem('params');
      if (Object.keys(params).length > 0) {
        this.queryParams = params;
      } else {
        this.queryParams = sessionStorageSelectedParams ? JSON.parse(sessionStorageSelectedParams) : {};
        this.sessionStorage.params = { ...this.queryParams };
        if (Object.keys(this.queryParams).length) {
          this.gisUtils.setSelectedParams(this.queryParams);
        }
      }
      if (!isNullOrUndefined(this.queryParams) && Object.keys(this.queryParams).length > 0) {
        this.selectedSource = this.queryParams['source'] == 'IMD_LONG_RANGE' ? 'IMD - GFS' : 'ECMWF'
        // if (this.blockNum == 3) {
        this.dateIndexLength = 7
        for (let i = 0; i < this.dateIndexLength; ++i) {
          if (i === this.blockNum) {
            this.activeRadioList.push(true);
          } else {
            this.activeRadioList.push(false);
          }
        }
      }
    });
    this.subscriptions.push(selectedParamsRef)
  }

  setParams() {
    if (this.isInitialLoad && !Object.keys(this.sessionStorage.params).length) {
      this.requestSelectedFilterParams();
    }
    this.isInitialLoad = false;
  }

  ngOnChanges(change: SimpleChanges) {
    let timeStamp = this.labelStrings[this.blockNum].groupName;
    this.gisUtils.setTimeStamp(timeStamp)
    if (!isNullOrUndefined(change.blockNum) && Object.keys(this.labelStrings).length > 0) {
      if (change.blockNum.currentValue) {
        this.buttonClicked(change.blockNum.currentValue);
      }

    } else {
      this.buttonClicked(this.blockNum);
    }
    const len = this.activeRadioList.length;
    this.activeRadioList = [];
    for (let i = 0; i < this.dateIndexLength; ++i) {
      if (i === this.blockNum) {
        this.activeRadioList.push(true);
      } else {
        this.activeRadioList.push(false);
      }
    }
  }

  buttonClicked(blockNumber, from?: string) {
    if (from === 'HTML') {
      this.playPos.emit(blockNumber);
      localStorage.setItem("playBarIndex", blockNumber)
    }
    if (this.activeRadioList[blockNumber]) {
      this.gisUtils.setIndex(this.labelStrings[blockNumber]['groupName']);
    }
  }

  validate(i) {
    if (this.labelStrings[i] == undefined || this.labelStrings[i] == null) {
      return ""
    }
    else {
      return this.labelStrings[i]['fullLabel'];
    }
  }

  sourceChange() {
    this.requestSelectedFilterParams()
  }

  requestSelectedFilterParams() {
    let currentUrlParams: any = {};
    if (!this.isInitialLoad) {
      currentUrlParams = this.queryParams;
    }
    currentUrlParams['component'] = 'HEATINDEX';
    currentUrlParams['source'] = this.sourceMapping[this.selectedSource]
    if (this.isInitialLoad) {
      currentUrlParams['actionType'] = 'filter';
      currentUrlParams['view'] = 'Admin';
      currentUrlParams['pType'] = 'COUNTRY';
      currentUrlParams['cType'] = 'STATE';
      currentUrlParams['parentLoc'] = 'COUNTRY';
      currentUrlParams['dashboardView'] = 'INDIA';
      currentUrlParams['dashboardType'] = 'gis';
      const userLocationConfig = this.dataService.formQuerParamsVariables(this.gisMapComp.metaInfo.userDetailsJson.data.location, this.gisMapComp.metaInfo.userDetailsJson.data.locType);
      const currentLocations: any = userLocationConfig.locationInfo[userLocationConfig.types.pType.toLowerCase()].split('##');
      currentUrlParams['pUUID'] = currentLocations[1]
      currentUrlParams['locName'] = currentLocations[0]
      currentUrlParams['locType'] = userLocationConfig.types.pType;
      currentUrlParams['pEUUID'] = userLocationConfig.locationInfo.country.split('##')[1];
      currentUrlParams['location'] = userLocationConfig.locationInfo.location;
      currentUrlParams['source'] = this.sourceMapping[this.selectedSource] || 'IMD_LONG_RANGE'
      this.isInitialLoad = false
    }
    currentUrlParams['viewType'] = currentUrlParams['viewType'] || 'BLOCK';
    this.gisUtils.setSelectedParams(currentUrlParams);
  }

  infoclick(value) {
    this.modalRef = this.modalService.open(InfomodalComponent, { backdrop: 'static', keyboard: true, windowClass: 'backgroundTransparent  infocomponent' })
    this.modalRef.componentInstance.selected = value;
  }

  ngOnDestroy(): void {
    this.destroy.next(true);
    this.destroy.complete();
    this.subscriptions.forEach((subscription: Subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    })
  }

}
